import { Image, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OnboardingButton.css';
import { IChatbotOnboardingButtonSchema } from '../../types/chatbot';

type TOnboardingButtonProps = {
  onboardingButton?: IChatbotOnboardingButtonSchema;
  onClick(onboardingButton?: IChatbotOnboardingButtonSchema): void;
};

export const OnboardingButton: React.FC<TOnboardingButtonProps> = ({ onboardingButton, onClick }) => {
  const handleClick = React.useCallback(() => {
    onClick(onboardingButton);
  }, [onboardingButton, onClick]);

  return (
    <div className={styles['card-container']} onClick={handleClick}>
      <div className={styles['text-block']}>
        <UIText2 color="text-main-default" fontWeight="bold" display="inline">
          {onboardingButton?.highlightedText}
        </UIText2>
        <UIText2 display="inline"> </UIText2>
        <UIText2 color="text-secondary-default" display="inline">
          {onboardingButton?.regularText}
        </UIText2>
      </div>
      <div className={styles['image-block']}>
        <div className={styles['image-content']}>
          <Image src={onboardingButton?.icon ?? ''} width={16} height={16} />
        </div>
      </div>
    </div>
  );
};
